// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1GtMh","content":"styles_content__34zeI","selectAll":"styles_selectAll__-pCk0"};